export const ALL_COMMS = 'allComms';
export const NEWSLETTER = 'newsletter';
export const EOI_ONLY = 'eoiOnly';
export const UNSUBSCRIBED = 'unsubscribed';
